import { render, staticRenderFns } from "./pnrbazlirapor.vue?vue&type=template&id=30a29271&scoped=true"
import script from "./pnrbazlirapor.vue?vue&type=script&lang=js"
export * from "./pnrbazlirapor.vue?vue&type=script&lang=js"
import style0 from "./pnrbazlirapor.vue?vue&type=style&index=0&id=30a29271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a29271",
  null
  
)

export default component.exports